import React, { Component } from 'react';
import CountUp from 'react-countup';

class TotalHUMIDUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      myValue: this.props.value // Replace this with your value from the backend or any other source
    };
  }

  render() {
    return (
      
        <div className="totalhitsbox">
          <p>Total HUMID Users</p>
          <div className="totalhitsvalue-container"><CountUp start={0} end={this.props.value} duration={10} suffix="+"/></div>
        </div>
      
    );
  }
}

export default TotalHUMIDUsers;
